import React from "react";

import SpLink from "../../../shared/SpLink";

import styles from "./PollenNavItem.module.scss";

type PollenNavItemType = {
  path: string;
  name: string;
};

const PollenNavItem: React.FC<PollenNavItemType> = ({ path, name }) => (
  <li role="menuitem" className={styles.topic}>
    <SpLink path={path} className={styles.topicLink}>
      {name}

      <svg className={styles.topicLinkIcon}>
        <use href="/icons/chevrons.svg#chevron-right"></use>
      </svg>
    </SpLink>
  </li>
);

export default PollenNavItem;
